import { CreateHelpPendencyMessage } from 'domain/usecases/surgical-pendency/create-help-pendency-message'
import { FinishHelpPendency } from 'domain/usecases/surgical-pendency/finish-help-pendency'
import { SurgicalPendencyRepository } from 'repository/interfaces/surgical-pendency-repository'

export class RemoteFinishHelpPEndency implements FinishHelpPendency {
  constructor(
    private readonly surgicalPendencyRepository: SurgicalPendencyRepository
  ) {}

  answer(
    params: FinishHelpPendency.Params
  ): Promise<CreateHelpPendencyMessage.Model> {
    return this.surgicalPendencyRepository.finishHelpPendency(params)
  }
}
